import { useCartAndDeliveryDatesDataContext } from '@app/data/clients/cartCheckoutClient';
import { UserInfo } from '@redbubble/next/types';
import { useUserInfo } from '@redbubble/next-provider';

export const useCurrency = () => {
  const { cart } = useCartAndDeliveryDatesDataContext();
  const [{ currency }] = useUserInfo<UserInfo>();

  return cart?.currency || currency;
};
